// Hit testing and readout helpers for the hover crosshair (pure; the component applies them to the DOM).
import { dur } from "./format";
import { nearest, timeAt } from "./layout";
import type { HoverHit, RowSource, SeriesRow, View } from "./types";

/** The sample under a pointer at clientX, given the SVG's client box. */
export function hitAt(view: View, clientX: number, box: { left: number; width: number }): HoverHit | null {
  const px = ((clientX - box.left) / box.width) * view.W;
  const r = nearest(view.rows, timeAt(view, px));
  if (!r) return null;
  return {
    row: r,
    cx: view.x(r.t).toFixed(1),
    pool: r.pool == null ? null : view.y(r.pool).toFixed(1),
    oracle: r.oracle == null ? null : view.y(r.oracle).toFixed(1),
    gap: r.basis == null ? null : view.yg(r.basis).toFixed(1),
  };
}

/** Readout position inside #chart-wrap: right of the pointer, or left of it past 60 percent of the width. */
export function readoutPosition(
  clientX: number, clientY: number,
  wrap: { left: number; top: number; width: number; height: number },
  box: { width: number; height: number },
): { left: number; top: number } {
  const left = clientX - wrap.left;
  return {
    left: left > wrap.width * 0.6 ? left - box.width - 14 : left + 14,
    top: Math.max(8, Math.min(clientY - wrap.top - 20, wrap.height - box.height - 8)),
  };
}

export function readoutSource(src: RowSource): string {
  return src === "hourly" ? "hourly close" : src === "live" ? "live, DexScreener" : "monitor reading";
}

export function readoutAge(r: SeriesRow): string {
  return r.updatedAt != null ? dur(r.t - r.updatedAt) : "n/a";
}

/** chart.js compared `r.basis >= 0`, where a null basis coerces to 0 and reads as positive. Kept. */
export function gapClass(basis: number | null): "pos" | "neg" {
  return basis == null || basis >= 0 ? "pos" : "neg";
}
